import * as React from 'react';
import * as moment from 'moment';
import { IDonorRegistration } from '@nkr/models/donor-registration';
import { IMicrositeRecipient } from '@nkr/models/microsites';
import { Col, Label, Row } from 'react-bootstrap';
import { cardBodyStyle, cardBodyTitleStyle, cardStyle, cardBodyTitleTextStyle } from '../../styles';

interface IProps {
    data: IDonorRegistration,
    microsite: IMicrositeRecipient
}

const MicrositeInfo = ({ data, microsite }: IProps) => {
    return (
        <div id='microsite-info' style={cardStyle}>
            <div style={cardBodyStyle}>
                <div style={cardBodyTitleStyle}>
                    <span style={cardBodyTitleTextStyle}>
                        {microsite.center != null ?
                            <>Registered for Microsite Patient at {microsite.center.alias}</>
                            :
                            <>Registered for Microsite Patient</>
                        }
                    </span>
                </div>
                <Row>
                    <Col xs={6} sm={4}>
                        <strong>Patient's Name:</strong>
                    </Col>
                    <Col xs={6} sm={2}>
                        <a href={`${__NKR_ORG_URL__}/${microsite.shortCode}`} target='_blank'>
                            {microsite.firstName} {microsite.lastName}
                        </a>
                    </Col>
                    <Col xs={6} sm={4}>
                        <strong>Patient's DOB:</strong>
                    </Col>
                    <Col xs={6} sm={2}>
                        {data.ddKnowsRecipDob ? moment(data.ddRecipDob).format('M/D/YYYY') : 'Doesn\'t know'}
                    </Col>
                </Row>

                <Row>
                    <Col xs={6} sm={4}>
                        <strong>Microsite Status:</strong>
                    </Col>
                    <Col xs={6} sm={2}>
                        {microsite.currentStatusDescription}
                    </Col>
                    <Col xs={6} sm={4}>
                        <strong>How registrant knows patient:</strong>
                    </Col>
                    <Col xs={6} sm={2}>
                        {data.ddRelationshipToPatient}
                    </Col>
                </Row>
                <Row>
                    <Col xs={6} sm={4}>
                        <strong>Patient's Coordinator:</strong>
                    </Col>
                    <Col xs={6} sm={2}>
                        {microsite.coordinatorContact?.fullName ?? ''}
                    </Col>
                    <Col xs={6} sm={4}>
                        <strong>Coordinator's Phone:</strong>
                    </Col>
                    <Col xs={6} sm={2}>
                        {microsite.coordinatorContact?.phoneNumbers[0]?.number ?? ''}
                    </Col>
                </Row>

                <Row>
                    <Col xs={6} sm={4}>
                        <strong>Coordinator's Email:</strong>
                    </Col>
                    <Col xs={6} sm={8}>
                        {microsite.coordinatorContact?.email ?? ''}
                    </Col>
                </Row>
                <Row>
                    <Col xs={6} sm={4}>
                        <strong>Patient's ABO:</strong>
                    </Col>
                    <Col xs={6} sm={2}>
                        {data.micrositeMatchQuality?.micrositeAbo ?? '?'}
                    </Col>
                    <Col xs={6} sm={4}>
                        <strong>Registrant's ABO:</strong>
                    </Col>
                    <Col xs={6} sm={2}>
                        {data.aboType ?? '?'}
                    </Col>
                </Row>
                <Row>
                    <Col xs={6} sm={4}>
                        <strong>Eplet Mismatch:</strong>
                    </Col>
                    <Col xs={6} sm={2}>
                        {data.micrositeMatchQuality?.dqMismatch >= 15
                            ? <Label bsStyle='danger'>High</Label>
                            : (
                                (data.micrositeMatchQuality?.drMismatch < 7 && data.micrositeMatchQuality?.dqMismatch < 9)
                                    ? <Label bsStyle='success'>Low</Label>
                                    : <Label bsStyle='warning'>Med</Label>
                            )
                        }
                    </Col>
                    {data.micrositeMatchQuality?.alleleMatchOf8 &&
                        <>
                            <Col xs={6} sm={4}>
                                <strong>Allele Match:</strong>
                            </Col>
                            <Col xs={6} sm={2}>
                                {data.micrositeMatchQuality?.alleleMatchOf8}/8
                            </Col>
                        </>
                    }
                </Row>
            </div>
        </div>
    );
}

export default MicrositeInfo;